import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService } from 'ng-jhipster';

import { Master } from './master.model';
import { MasterPopupService } from './master-popup.service';
import { MasterService } from './master.service';
import {RegionService} from '../../admin/user-management/region.service';
import {Academy} from '../../admin/user-management/region.model';
import {isNullOrUndefined} from 'util';
import {CampaignService} from '../campaign/campaign.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-master-dialog',
    templateUrl: './master-dialog.component.html'
})
export class MasterDialogComponent implements OnInit, OnDestroy {

    master: Master;
    academies = [];
    isSaving: boolean;
    campaign: string;

    private subscription: Subscription = new Subscription();

    constructor(
        public activeModal: NgbActiveModal,
        private alertService: AlertService,
        private masterService: MasterService,
        private eventManager: EventManager,
        private regionService: RegionService,
        private campaignService: CampaignService
    ) {
    }

    ngOnInit() {
        this.isSaving = false;
        this.subscription.add(this.regionService.getRegions({'campaign': this.campaignService.getDisplayedCampaign()}).subscribe(regions => {
            regions.forEach(reg => {
                if (!isNullOrUndefined(reg.academies)) {
                    reg.academies.forEach(aca => {
                        if (!isNullOrUndefined(aca)) {
                            aca.academicRegionLabel = reg.academicRegionLabel;
                            this.academies.push(aca);
                        }
                    });
                }
            });
        }));
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        let academy: Academy = this.academies.find(aca => aca.academyCode === this.master.academyCode);
        this.master.academyLabel = academy.academyLabel;
        this.master.academicRegionLabel = academy.academicRegionLabel;

        if (this.master.id !== undefined) {
            this.masterService.update(this.master)
                .subscribe((res: Master) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.masterService.create(this.master)
                .subscribe((res: Master) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: Master) {
        this.eventManager.broadcast({ name: 'masterListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}

@Component({
    selector: 'jhi-master-popup',
    template: ''
})
export class MasterPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private masterPopupService: MasterPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.masterPopupService.open(MasterDialogComponent, params['id']);
            } else {
                this.modalRef = this.masterPopupService.open(MasterDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master-dialog.component.ts